import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Rankings from "./Rankings";
import { useResolvedPath } from "react-router-dom";
import MUIButton from "../UI/MUIButton/MUIButton";
import { Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SentimentTable from "./SentimentTable";
import { transformDriverData, formatSectionLabel } from "../../utils/helpers";
import SentimentDriversTable from "./SentimentDrivers";
import { useState, useContext } from "react";
import { DiscoveryContext } from "../../luminaire/BrandAudit/discovery-context";
import api from "../../BrandOnBoarding/api";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import Spinner from "../Spinner/Spinner";
import classes from "./BrandIndexBreakups.module.css";
import useBaseResponsesModal from "../../Component/BaseResponseComponent/useBaseResponsesModal";
import BaseResponsesModal from "../../Component/BaseResponseComponent/BaseResponsesModal";
import { AuthContext } from "../../context/auth-context";
import { ENTITY_LABELS } from "../../utils/labelMapping";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function BrandReachSentimentMeta({
  data,
  isReach,
  addToActionHandler,
  sources,
  isComp,
  isMainBrand,
  selectedBrandProduct,
  score,
  categoryName,
  type,
  isOverview,
  selectedInput
}) {
  const { pathname } = useResolvedPath();

  let selectedOptionShow = type ? type : ENTITY_LABELS.product;
  if (pathname.includes("brand-monitoring")) {
    selectedOptionShow = ENTITY_LABELS.brand;
  }


  const [sentimentDrivers, setSentimentDrivers] = useState(
    data?.sentiementKeyDrivers
  );
  const [isLodaing, setIsLoading] = useState(false);

  const {
    infoModalOpen, infoModalTitle, infoModalContent,
    closeInfoModal, hasSections, productMappingAttribute,
    handleInfoClick, handleAllBaseResponsesClick,
  } = useBaseResponsesModal(data,"visibility");

  const { user } = useContext(AuthContext);
  const isCompanyUser = user?.user_role?.role?.name === "Company user";

  const handleSentimentDrivers = async () => {
    const payload = {
      sentimentMeta: data?.sentimentMeta,
    };
    try {
      setIsLoading(true);
      const response = await api.post("/metrics/sentiment-drivers", payload);
      setSentimentDrivers(response.data);
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  const discoveryCtx = useContext(DiscoveryContext);
  const isPropensity = discoveryCtx?.isPropensityToBuy?.() ?? (discoveryCtx?.brand_scores?.rbiType === "propensityToBuy");
  const mapTitle = (t) => discoveryCtx?.mapMetricTitle?.(t) ?? t;

  const renderAddToActionButton = () => {
    if ((!isComp && isMainBrand) || isMainBrand) {
      let targetSources;
      if (isOverview) {
        targetSources = isReach
          ? Object.keys(data?.rankSources?.rank)
          : data?.sentimentSources;
      }
      else {
        targetSources = isReach
          ? data?.reachSourceData
          : sources?.sentimentSourceData;
      }

      const actionStatement = `The ${isReach ? ENTITY_LABELS.rank : "Sentiment"
        }- Score for the ${selectedOptionShow} ${selectedBrandProduct} is ${score}`;

      const rationale =
        !isReach &&
          Array.isArray(data?.sentimentMeta) &&
          data.sentimentMeta.length > 0
          ? data.sentimentMeta[0]?.[0]?.response || ""
          : "";

      return (
        <MUIButton
          size="small"
          // className={classes.action_btn}
          variant="outlined"
          onClick={() => {
            addToActionHandler(actionStatement, rationale, targetSources);
          }}
        >
          Add To Action
        </MUIButton>
      );
    }
  };

  return (
    <>
      <h3>
        {`${selectedOptionShow} ${isReach ? mapTitle(ENTITY_LABELS.rank) : mapTitle("Sentiment")} Score`}
      </h3>
      {
        <Typography variant="button" color="textSecondary">
          {categoryName ?? ""}
        </Typography>
      }
      {/* <p style={{ color: "gray", fontStyle: "italic", marginTop: "10px" }}>
        Note: The displayed metadata is from one of the datasets in the selected
        timeframe, while the scores on the UI represent the average of the same
        timeframe.
      </p>
      <hr /> */}
      <div className="mx-4">
        <TableContainer>
          {isReach && (
            <>
              <h5>{mapTitle(ENTITY_LABELS.rank)}</h5>
              <hr />
              <div className="mx-1">
                {data?.productRankingsArray && (
                  <>
                    {data?.productRankingsArray && (
                      <div className="container">
                        <div className="row">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <h6 style={{ margin: 0 }}>{`A. ${mapTitle(`${ENTITY_LABELS.rank} Data`)}`}</h6>
                            {data?.baseResponses?.length >0 && (
                              <InfoOutlinedIcon
                                className={classes.info_icon}
                                onClick={handleAllBaseResponsesClick}
                              />
                            )}
                          </div>
                          <hr />
                          <div style={{ display: "flex", flexDirection: hasSections ? "column" : "row" }}>
                            {hasSections ? (
                              (() => {
                                let globalIndex = 0;

                                return Object.entries(productMappingAttribute).map(
                                  ([sectionKey, indices]) => {
                                    const sectionIndices = indices.map(() => globalIndex++);

                                    return (
                                      <div key={sectionKey} className={classes.section_block}>
                                        <div className={classes.section_header}>
                                          <h6 style={{ margin: 0 }}>
                                            {formatSectionLabel(sectionKey)}
                                          </h6>
                                          {!isCompanyUser && <InfoOutlinedIcon
                                            className={classes.info_icon}
                                            onClick={() =>
                                              handleInfoClick(sectionKey, indices)
                                            }
                                          />}
                                        </div>
                                        <div style={{ display: "flex" }}>
                                          <Rankings
                                        rankings={indices.map(
                                          (i) => data.productRankingsArray[i]
                                        )}
                                            pIndices={indices}
                                            sectionIndices={sectionIndices}
                                            rankMatchesIndices={data?.rankMatchesIndices}
                                            name={
                                              data?.favorabilities?.length > 0
                                                ? data?.favorabilities[0]?.name
                                                : ""
                                            }
                                          />
                                        </div>
                                      </div>
                                    );
                                  }
                                );
                              })()
                            ) : (
                              <Rankings
                                rankings={data?.productRankingsArray}
                                rankMatchesIndices={data?.rankMatchesIndices}
                                name={
                                  data?.favorabilities?.length > 0
                                    ? data?.favorabilities[0]?.name
                                    : ""
                                }
                              />
                            )}
                          </div>
                          <hr />
                        </div>
                      </div>
                    )}{" "}
                    <hr />
                  </>
                )}
                <h6>
                  {data?.productRankingsArray ? "B" : "A"}. {mapTitle(`Average ${ENTITY_LABELS.rank} Scores`)}
                </h6>
                <hr />
                <Table
                  sx={{ minWidth: 650 }}
                  size="medium"
                  aria-label="simple table"
                >
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Name</StyledTableCell>
                      <StyledTableCell align="right">Score</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {data?.rank && data?.rank.length > 0
                      ? data?.rank.length === 1
                        ? data?.rank?.map((row) => (
                          <StyledTableRow
                            key={row.name}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <StyledTableCell component="th" scope="row">
                              {row.name}
                            </StyledTableCell>
                            <StyledTableCell align="right">
                              {row.score}
                            </StyledTableCell>
                          </StyledTableRow>
                        ))
                        : data?.rank
                          ?.filter(
                            (item) => item.name === selectedBrandProduct
                          )
                          ?.map((row) => (
                            <StyledTableRow
                              key={row.name}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <StyledTableCell component="th" scope="row">
                                {row.name}
                              </StyledTableCell>
                              <StyledTableCell align="right">
                                {row.score}
                              </StyledTableCell>
                            </StyledTableRow>
                          ))
                      : null}
                  </TableBody>
                </Table>
              </div>
            </>
          )}
          {!isReach && (
            <>
              <h5>{mapTitle("Sentiment")}</h5>
              <hr />
              <div className="mx-1">
                {data?.sentimentMeta && <SentimentTable showInfoIcon={!isCompanyUser} selectedInput={selectedInput} data={data} />}
              </div>
              <hr />
              <div style={{ display: "flex", alignItems: 'center' }}>
                <h5>{`3. ${mapTitle("Sentiment Drivers")}`}</h5> &nbsp; &nbsp;
                {!sentimentDrivers ? (
                  !isLodaing ? (
                    <MUIButton
                      onClick={handleSentimentDrivers}
                      variant="outlined"
                      // className={classes.regenerate}
                      startIcon={<AutoAwesomeOutlinedIcon />}
                    >
                      Generate
                    </MUIButton>
                  ) : (
                    <Spinner />
                  )
                ) : null}
              </div>

              {sentimentDrivers && Object.keys(sentimentDrivers).length > 0 && (
                <>
                  {/* <hr />
                  <h5>3. Sentiment Drivers</h5> */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.5rem",
                    }}
                  >
                    {sentimentDrivers?.positive &&
                      sentimentDrivers?.positive.length > 0 && (
                        <div style={{ flex: 1, minWidth: "40%" }}>
                          <SentimentDriversTable
                            data={transformDriverData(
                              sentimentDrivers?.positive,
                              "Positive"
                            )}
                            title={isPropensity ? mapTitle("Positive Sentiment Drivers") : "Positive Sentiment Drivers"}
                          />
                        </div>
                      )}

                    {sentimentDrivers?.negative &&
                      sentimentDrivers?.negative.length > 0 && (
                        <div style={{ flex: 1, minWidth: "40%" }}>
                          <SentimentDriversTable
                            data={transformDriverData(
                              sentimentDrivers?.negative,
                              "Negative"
                            )}
                            title={isPropensity ? mapTitle("Negative Sentiment Drivers") : "Negative Sentiment Drivers"}
                          />
                        </div>
                      )}
                  </div>
                </>
              )}
            </>
          )}
          <p></p>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {renderAddToActionButton()}
          </div>
        </TableContainer>
      </div>
      <BaseResponsesModal
        open={infoModalOpen}
        title={infoModalTitle}
        content={infoModalContent}
        onClose={closeInfoModal}
      />
    </>
  );
}
